import React from 'react';
import { Button } from "../ui/button";

const Pagination = ({ items, rowsPerPage, currentPage, setCurrentPage, handleNextPage, handlePreviousPage, handlePageClick }) => {
    const totalPages = Math.ceil(items.length / rowsPerPage);

    return (
        <div className="flex justify-center items-center mt-4 gap-2">
            <Button
                variant="outline"
                size="sm"
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
            >
                ← Précédent
            </Button>
            {[...Array(totalPages)].map((_, index) => (
                <Button
                    key={index}
                    variant={currentPage === index + 1 ? "default" : "outline"}
                    size="sm"
                    onClick={() => handlePageClick(index + 1)}
                >
                    {index + 1}
                </Button>
            ))}
            <Button
                variant="outline"
                size="sm"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
            >
                Suivant →
            </Button>
        </div>
    );
};

export default Pagination;
